import { SET_US_FORM_TYPE } from "../actionTypes";

const intialState = {
  usFormType: "ES",
};
const formTypeReducer = (state = intialState, action) => {
  switch (action.type) {
    case SET_US_FORM_TYPE:
      return {
        ...state,
        usFormType: action.usFormType,
      };

    default:
      return state;
  }
};
export default formTypeReducer;
